import React from "react";
import { CircularProgress } from "@mui/material";

const SpinnerOverlay = (props) => {
  const styles = {
    spinner: {
      position: props.relative ? 'relative' : 'absolute',
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      opacity: "1",
      zIndex: 2
    }
  };

  return (
    <div style={styles.spinner}>
      <CircularProgress style={{ color: 'green' }} />
    </div>
  );
};

export default SpinnerOverlay;
